module.exports = __webpack_public_path__ + "static/media/a-2-b.5dbc30c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-2-b.jpg
// module id = 1093
// module chunks = 33